/**
 * Shared types and enums for play components.
 * This file exists to break circular dependencies between play-context.tsx and play-offer-node-select.tsx
 */

export enum OfferNodeType {
  OFFER = 'offer',
  TEST = 'test',
  SUB_AUDI_SPLIT = 'sub_aud_split',
}

export enum PlayObjectProperty {
  AUDIENCE_ID = 'audience_id',
  CONTROL_PERCENTAGE = 'draft_control_percentage',
  CONTROL_TARGET = 'draft_control_target',
  OFFER_PERCENTAGE = 'draft_offer_percentage',
  LIVE_CONTROL_PERCENTAGE = 'live_control_percentage',
  LIVE_CONTROL_TARGET = 'live_control_target',
  LIVE_OFFER_PERCENTAGE = 'live_offer_percentage',
  PLAY_TRIGGER = 'trigger_rules',
  PLAY_TITLE = 'play_title',
  PLAY_TYPE = 'play_type',
  PRESENTATION = 'presentation',
  LIVE_PRESENTATION = 'live_presentation',
  OFFER_NODE_TYPE = 'offer_node_type',
  CONTROL_NODE = 'draft_control_node',
  OFFER_NODE = 'draft_offer_node',
  LIVE_CONTROL_NODE = 'live_control_node',
  LIVE_OFFER_NODE = 'live_offer_node',
  BRAND_ID = 'brand_id',
  PRIORITY = 'priority',
}

export enum TriggerEventType {
  PAGE_VISIT = 'page_visit',
  ANY_PAGE_VISIT = 'any_page_visit',
  ON_CLICK = 'on_click',
  OTHER = 'other',
}
